var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrderModeLeft = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 80,
    viewBox: "0 0 176 80",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 175,
    height: 79,
    rx: 5.5,
    fill: "#150942"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "border",
    x: 0.5,
    y: 0.5,
    width: 175,
    height: 79,
    rx: 5.5,
    stroke: "#9999AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 27,
    height: 68,
    rx: 4,
    fill: "#9999AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 66a2 2 0 0 1 2-2h21a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-4Z",
    fill: "#00D1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-6Z",
    fill: "#C53030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-5Z",
    fill: "#C9C9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 33a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-9Z",
    fill: "#11946B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-9Z",
    fill: "#C9C9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-6Z",
    fill: "#11946B"
  })));
};
export default SvgOrderModeLeft;